import AutoplayVideo from"./src/AutoplayVideo";if(!window.customElements.get("autoplay-video")){window.customElements.define("autoplay-video",AutoplayVideo)}